import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { Row, Col, Form, Button } from '_zari/core'

import * as CompaniaService from 'services/compania.service'

import * as FormGroups from './formGroups'

import { ZrSwal } from 'utils'

const ExternoForm = ({ edicionData }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      file: edicionData.logo || ''
    }
  }, [edicionData])

  const onSubmit = React.useCallback(
    (data, { setSubmitting }) => {
      const submitData = new FormData()
      submitData.append('file', data.file)
      CompaniaService.insertarActualizarCompaniaLogoExterno(submitData)
        .then(() => {
          __zariContext.snack('success', 'Se ha actualizado el logo.')
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
        })
        .finally(() => {
          setSubmitting(false)
        })
    },
    [__zariContext]
  )

  const onClickDelete = React.useCallback(() => {
    ZrSwal.showAlert({
      tipo: 'warning',
      mensaje: 'Esta seguro de eliminar el logo externo de la compañía actual.',
      showCerrar: true,
      onSuccess: () => {
        CompaniaService.eliminarCompaniaLogoExterno()
          .then(() => {
            __zariContext.snack('success', 'El logo externo ha sido eliminado.')
            window.location.reload()
          })
          .catch(({ data: { error } }) => {
            __zariContext.snack('error', error)
          })
      }
    })
  }, [__zariContext])

  return (
    <Formik initialValues={formInitialValues} onSubmit={onSubmit}>
      {({ values, setFieldValue, isSubmitting, handleSubmit}) => (
        <Form>
          <Row>
            {edicionData !== '' && edicionData !== '' && (
              <Col md={4}>
                <img src={edicionData} alt="Base64" style={{ maxWidth: '100px', maxHeight: '100px' }} />
              </Col>
            )}
            <Col md={8}>
              <FormGroups.LogoEmpresaFormGroup
                setFieldValue={setFieldValue}
                iValue={values.logoEmpresa}
                fIsSubmitting={isSubmitting}
              />
            </Col>
          </Row>
          <Row className='mt-2'>
            <Col md={12} className='text-right'>
              <Button color='danger' disabled={isSubmitting} onClick={() => onClickDelete()}>
                Eliminar
              </Button>
              <Button disabled={isSubmitting} onClick={handleSubmit}>
                Procesar
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  )
}

export default React.memo(ExternoForm)
